export default {
  startshopping: {
    subtitle: "FOR RESTAURANTS",

    title1: "Start Ordering in",
    title2: "3 Simple Steps",

    desc:
      "Get started with MAHAL quickly and manage your restaurant procurement with ease.",

    step1: {
      title: "Create Your Account",
      desc: "Register your restaurant and set up delivery details in just a few minutes.",
      btn: "Create Account →",
    },

    step2: {
      title: "Explore Marketplace",
      desc: "Browse verified suppliers, compare prices, and add products to your cart.",
      btn: "Explore Marketplace →",
    },

    step3: {
      title: "Place & Track Orders",
      desc: "Confirm delivery and track your orders till they reach your kitchen.",
      btn: "Track Orders →",
    },
  },
};